import { GenerateImagesPaycase } from '~features/annals/enums/generateImagesPaycase';

import { isData, isStep } from './guards';
import type {
	BotWizardContentDependencyData,
	BotWizardContentDependencyStep,
	BotWizardFieldNames,
	BotWizardFieldSliders,
	BotWizardValues,
	BotWizardValueSimple,
	BotWizardValueSliders,
	Paycase,
} from './types';

export const getDependencyContent = <T>({
	data,
	values,
	contentDependency = [],
}: {
	data: BotWizardContentDependencyData<T>;
	values: BotWizardValues;
	contentDependency?: BotWizardFieldNames[];
}) => {
	let currentData = data;
	let iteration = 0;
	while (currentData) {
		if (isData(currentData)) {
			return currentData;
		} else {
			currentData =
				currentData[
					(values[contentDependency[iteration]] as BotWizardValueSimple) ?? ''
				];
			iteration++;
		}
	}
	return null;
};

export const getDependencyStep = ({
	step,
	values,
	contentDependency = [],
}: {
	step: BotWizardContentDependencyStep;
	values: BotWizardValues;
	contentDependency?: BotWizardFieldNames[];
}) => {
	let currentStep = step;
	let iteration = 0;
	while (currentStep) {
		if (isStep(currentStep)) {
			return currentStep;
		} else {
			currentStep =
				currentStep[
					(values[contentDependency[iteration]] as BotWizardValueSimple) ?? ''
				];
			iteration++;
		}
	}
	return null;
};

export const convertSliderValueToQuery = (
	value: BotWizardValueSliders,
	field: BotWizardFieldSliders
) => {
	if (!value) {
		return {};
	}
	return {
		[field.queryKey]: value.preset,
		...Object.fromEntries(
			field.data.sliders.map((slider) => [
				field.queryKey + slider.queryKey,
				value.values[slider.id],
			])
		),
	};
};

export function switchPaycase(
	hasSubscription: boolean,
	hasFree: boolean,
	hasBalance: boolean
): [Paycase, GenerateImagesPaycase] {
	switch (true) {
		case hasFree:
			return ['free', GenerateImagesPaycase.Free];
		case !hasSubscription:
			return ['subscription', GenerateImagesPaycase.Subscription];
		case !hasBalance:
			return ['neurons', GenerateImagesPaycase.Neurons];
		default:
			return ['paid', GenerateImagesPaycase.Neurons];
	}
}
